export { default } from "./ContentTeaser";
